module.exports = __webpack_public_path__ + "static/prestashop_logo-478b3e3ba113771eb01fee7e1a7026a6.svg";